import api, { checkTokenErrorResponse } from '..';


export async function getBillsPlans() {
    return api.get("planos_de_contas/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postBillsPlan(nome) {
    const formdata = new FormData();

    formdata.append("nome", nome)

    return api.post(`planos_de_contas/`,formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getBillsPlan(id) {
    return api.get(`planos_de_contas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteBillsPlan(id) {
    return api.delete(`planos_de_contas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function patchBillsPlan(id, nome) {
    const formdata = new FormData();

    formdata.append("nome", nome);

    return api.patch(`planos_de_contas/${id}/`,formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


const billsPlanServices = {
    getBillsPlan,
    getBillsPlans,
    postBillsPlan,
    deleteBillsPlan,
    patchBillsPlan,
}
export default billsPlanServices;